/**
 * A topic is its own indexable page (`/t/:tag`), not a homepage query param — a crawler follows a
 * path, and `server/seo/share-html.ts` renders the same shape for it.
 */
export function topicPath(topic?: string | null): string {
	const normalized = topic?.trim().toLowerCase();
	return normalized ? `/t/${encodeURIComponent(normalized)}` : "/";
}
